import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=3ba5ff20&scoped=true"
import script from "./Title.ts?vue&type=script&lang=ts&external"
export * from "./Title.ts?vue&type=script&lang=ts&external"
import style0 from "./Title.scss?vue&type=style&index=0&id=3ba5ff20&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5ff20",
  null
  
)

export default component.exports